import OTPInput from './otp-input';
export default OTPInput;
